import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container, Typography, Box, Paper, Button, Alert, CircularProgress, Grid
} from '@mui/material';
import api from '../../services/api';

const PaymentDetailsPage = () => {
  const { paymentId } = useParams();
  const navigate = useNavigate();
  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [refundLoading, setRefundLoading] = useState(false);
  const [success, setSuccess] = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');
    api.get(`/admin/payments/${paymentId}`)
      .then(res => {
        setPayment(res.data);
        setLoading(false);
      })
      .catch(err => {
        setError('Failed to fetch payment details');
        setLoading(false);
      });
  }, [paymentId, success]);

  const handleRefund = async () => {
    setRefundLoading(true);
    try {
      await api.post(`/admin/payments/${paymentId}/refund`);
      setSuccess('Refund issued successfully');
      // Refetch payment details to update status
      const res = await api.get(`/admin/payments/${paymentId}`);
      setPayment(res.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to issue refund');
    } finally {
      setRefundLoading(false);
    }
  };

  return (
      <Container maxWidth="sm" sx={{ mt: 0, mb: 4 }} disableGutters>
        <Button
          variant="outlined"
          onClick={() => navigate('/admin/payments')}
          sx={{ mb: 2 }}
        >
          ← Back to Payments
        </Button>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : payment ? (
          <Paper sx={{ p: 4 }}>
            <Typography variant="h5" gutterBottom>Payment Details</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}><Typography variant="subtitle2">Vendor</Typography><Typography variant="body1">{payment.business_name || '-'}</Typography></Grid>
              <Grid item xs={12}><Typography variant="subtitle2">Email</Typography><Typography variant="body1">{payment.email || '-'}</Typography></Grid>
              <Grid item xs={12}><Typography variant="subtitle2">Booth</Typography><Typography variant="body1">{payment.booth_number || '-'}</Typography></Grid>
              <Grid item xs={12}><Typography variant="subtitle2">Amount</Typography><Typography variant="body1">${Number(payment.amount).toFixed(2)}</Typography></Grid>
              <Grid item xs={12}><Typography variant="subtitle2">Status</Typography><Typography variant="body1">{payment.status}{payment.refund_id ? ' (Refunded)' : ''}</Typography></Grid>
              <Grid item xs={12}><Typography variant="subtitle2">Stripe Payment ID</Typography><Typography variant="body1">{payment.stripe_payment_intent_id}</Typography></Grid>
              <Grid item xs={12}><Typography variant="subtitle2">Date</Typography><Typography variant="body1">{new Date(payment.created_at).toLocaleString()}</Typography></Grid>
            </Grid>
            <Box sx={{ mt: 3 }}>
              {payment.status === 'succeeded' && !payment.refund_id ? (
                <Button
                  variant="outlined"
                  color="error"
                  disabled={refundLoading}
                  onClick={handleRefund}
                >
                  {refundLoading ? <CircularProgress size={16} /> : 'Refund'}
                </Button>
              ) : payment.refund_id ? (
                <Typography variant="body2" color="text.secondary">Refunded</Typography>
              ) : null}
            </Box>
          </Paper>
        ) : null}
      </Container>
  );
};

export default PaymentDetailsPage; 